module.exports = __webpack_public_path__ + "img/start.2615a492.svg";